import { runManifestFacts } from './run-manifest-facts.mts'

import type { BuildOptionHints } from './scripts/resolution-report-render.mts'
import type { SidecarAccumulator } from './scripts/sidecar.mts'

// Generates `pom.xml.socket.facts.json` (named after the POM Maven runs on)
// for a Maven project via the bundled extension.
export async function convertMavenToFacts({
  bin,
  cwd,
  excludeConfigs,
  excludePaths,
  hints,
  ignoreUnresolved,
  includeConfigs,
  javaHome,
  mavenOpts,
  sidecarAcc,
  verbose,
  withFiles,
}: {
  bin: string
  cwd: string
  excludeConfigs: string
  excludePaths?: string[] | undefined
  hints?: BuildOptionHints | undefined
  ignoreUnresolved: boolean
  includeConfigs: string
  javaHome?: string | undefined
  mavenOpts: string[]
  sidecarAcc?: SidecarAccumulator | undefined
  verbose: boolean
  withFiles?: boolean | undefined
}): Promise<void> {
  await runManifestFacts({
    bin,
    buildOpts: mavenOpts,
    cwd,
    ecosystem: 'maven',
    excludeConfigs,
    excludePaths,
    hints,
    ignoreUnresolved,
    includeConfigs,
    javaHome,
    sidecarAcc,
    verbose,
    withFiles,
  })
}
